module.exports = __webpack_public_path__ + "static/media/telethon-kids-2024@2x.589d58cb.png";